import { Component, ElementRef, Input } from '@angular/core';
import { JdOptionComponent } from './jd-option.component';
import {isNotNil} from '../core/convert';

@Component({
  selector   : '[jd-option-li]',
  templateUrl: './jd-option-li.component.html',
  host       : {
    '[class.ant-select-dropdown-menu-item]'         : 'true',
    '[class.ant-select-dropdown-menu-item-selected]': 'selected && !jdOption.jdDisabled',
    '[class.ant-select-dropdown-menu-item-disabled]': 'jdOption.jdDisabled',
    '[class.ant-select-dropdown-menu-item-active]'  : 'active && !jdOption.jdDisabled && jdShowActive && !selected',
    '[attr.unselectable]'                           : '"unselectable"',
    '[style.user-select]'                           : '"none"'
  }
})
export class JdOptionLiComponent {
  el: Element;
  selected = false;
  active = false;
  @Input() jdOption: JdOptionComponent;
  @Input() jdShowActive = true;
  // tslint:disable-next-line:no-any
  @Input() compareWith: (o1: any, o2: any) => boolean;

  @Input()
  set jdActiveOption(value: JdOptionComponent) {
    if (value) {
      this.active = this.compareWith(value.jdValue, this.jdOption.jdValue);
    } else {
      this.active = false;
    }
  }

  @Input()
  // tslint:disable-next-line:no-any
  set jdListOfSelectedValue(valueList: any[]) {
    this.selected = isNotNil(valueList.find(v => this.compareWith(v, this.jdOption.jdValue)));
  }

  constructor(private elementRef: ElementRef) {
    this.el = elementRef.nativeElement;
  }
}
